<template>
  <div>
    <c-tab
      type="vertical"
      :tabItems="child.tabItems"
      :height.sync="tabHeight"
      v-model="child.tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :key="tab.key"
          :patrol="patrol"
          :place.sync="tab.place"
          :contentHeight="contentHeight"
          @tranStep="tranStep"
          @research="research"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
// import { uid } from 'quasar'
export default {
  name: 'patrol-place',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
        research: '',
      }),
    },
    patrol: {
      type: Object,
      default: () => ({
        saiPatrolId: '',  // 순회점검 일련번호
        plantCd: '',  // 사업장 코드
        patrolName: '',  // 순회명
        patrolStartDate: '',  // 순회시작일
        patrolEndDate: '',  // 순회종료일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        patrolResultCd: null,  // 특이사항
        patrolResultSummary: '',  // 순회결과요약
        patrolStepCd: null,  // 진행상태
        regUserId: '',  //
        places: [],
        deletePlaces: [],
      }),
    },
    child: {
      type: Object,
      default: () => ({
        tab: '',
        tabItems: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
    };
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 60) + 'px';
    },
    // tab() {
    //   let text = '';
    //   if (this.tabItems && this.tabItems.length > 0) {
    //     text = this.tabItems[0].name
    //   }
    //   return text
    // },
    // tabItems() {
    //   let items = [];
    //   if (this.patrol.places && this.patrol.places.length > 0) {
    //     this.$_.forEach(this.patrol.places, place => {
    //       if (!place.patrolDate) {
    //         place.patrolDate = this.patrol.patrolStartDate
    //       } 
    //       items.push({
    //         // tab info
    //         key: uid(),
    //         name: place.placeId, icon: 'place', label: place.placeName,
    //         component: () => import(`${'./patrolPlaceResult.vue'}`),
    //         // place info
    //         place: place,
    //       })
    //     })
    //   }
    //   return items;
    // }
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting
    },
    tranStep() {
      this.$emit('transInfo', this.patrol.saiPatrolId)
    },
    research() {
      this.$emit('research')
    }
  }
};
</script>
